import LoyaltyHeader from "./loyaltyHeader";

export default {
  LoyaltyHeader,
};
